var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"py-0"},[_c('div',{staticClass:"tcdc-partner-card-border pa-5",on:{"click":_vm.onClick}},[_c('v-img',{staticClass:"tcdc-partner-card-image",attrs:{"eager":"","contain":"","src":_vm.img,"aspect-ratio":"1","max-height":"320px"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }